import { StyleSheet } from 'aphrodite/no-important';

const myGlobalExtension = {
  selectorHandler: (selector, _, generateSubtreeStyles) => {
    if (selector[0] !== '*') {
      return null;
    }

    return generateSubtreeStyles(selector.slice(1));
  }
};

const { css } = StyleSheet.extend([myGlobalExtension]);

/**
  Add global css
  @function cssGlobal
  @param {String} globalStyles JSON that represents the styles to add
*/
export default function cssGlobal(globalStyles) {
  const styles = {};

  Object.keys(globalStyles).forEach(key => {
    styles['*' + key] = globalStyles[key];
  });

  css(
    StyleSheet.create({
      global: styles
    }).global
  );
}



// WEBPACK FOOTER //
// ./src/utils/cssGlobal.js